<template>
	<div>
	  <div style="height: 100%;position: relative;">
	  	<div @click="handleSwitchNavbar" class="categoryDiv">
		      <icon class="category-icon" name="category" :scale="2"></icon>
		      <span style="vertical-align:middle;">功能菜单</span>
		  </div>
		  <div style="position: absolute;top: 72px;bottom: 15px;width: 100%;">
		  	<el-scrollbar wrapClass="scrollbar-wrapper" style="height: 100%;">
			    <el-menu
			      class="sidebar-menu"
			      mode="vertical"
			      :show-timeout="200"
			      :default-active="$route.path"
			      :collapse="isCollapse"
			      :background-color="bg"
			      :text-color="tc"
			      :active-text-color="atc">
			      <sidebar-item :routes="permission_routers"></sidebar-item>
			    </el-menu>
			</el-scrollbar>
		  </div>
	  </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarItem from './SidebarItem'

export default {
  name: 'Sidebar',
  data() {
    return {
      bg: '#303030',
      tc: '#fff',
      atc: '#fff'
    }
  },
  components: {
    sidebarItem
  },
  computed: {
    ...mapGetters(['sidebar', 'permission_routers']),
    isCollapse() {
      if (this.sidebar.sliderState === 'full') {
        return false
      }
      return true
    }
  },
  methods: {
    handleSwitchNavbar() {
      this.$store.dispatch('toggleSideBar')
    }
  }
}
</script>
<style>
.el-menu-item.is-active {
  background-color: #0099fb ;
  width: 85%;
  min-width: 175px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.categoryDiv{
	line-height: 72px;
	height: 72px;
	padding-left: 20px;
	font-size: 14px;
}
.categoryDiv:hover{
	cursor:pointer;
}
.category-icon{
	margin-right: 20px;
	vertical-align:middle;
}
</style>
